import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// @mui
import { Container, Card } from '@mui/material';
// components
import { useSettingsContext } from '../../../components/settings';
import MasterTabPanel from '../../../sections/setdealer/MasterTabPanel';
import SetDealerHeader from '../../../sections/setdealer/SetDealerHeader';
// ----------------------------------------------------------------------------------------------------------------

// AdminMasters.propTypes = {
//    importkey: PropTypes.string,
// };

export default function MainDealerPage() {
    const navigate = useNavigate();

    const { masterName } = useParams();
    const { themeStretch } = useSettingsContext();
    const [importHistoryColumns, setImportHistoryColumns] = useState([]);
    const [columnData, setColumnData] = useState([]);
    const [importHistoryRows, setImportHistoryRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [importHistoryLoading, setImportHistoryLoading] = useState(false);
    const [noOfRecords, setNoOfRecords] = useState(100);
    const [masterTitle, setMasterTitle] = useState('');

    const columns =
        [
            { field: 'acknowledgementstatus', headerName: 'Acknowledgement Status', width: 230, description: 'Acknowledgement Status' },
            { field: 'requestidandrequesttype', headerName: 'Request ID & Request Type', width: 200, description: 'Request ID & Request Type' },
            { field: 'dcnumber', headerName: 'DC Number', width: 150, description: 'DC Number' },
            { field: 'setName', headerName: 'Set Name', width: 130, description: 'Set Name' },
            { field: 'equipmentID', headerName: 'Equipment ID', width: 150, description: 'Equipment ID' },
            { field: 'equipmentassignmentstatus', headerName: 'Equipment Assignment Status', width: 200, description: 'Equipment Assignment Status' },
            { field: 'awb#', headerName: 'AWB#', width: 150, description: 'AWB#' },
            { field: 'dispacheddate', headerName: 'Dispached Date', width: 150, description: 'Dispached Date' },
            { field: 'acknowledgeddate', headerName: 'Acknowledged Date', width: 150, description: 'Acknowledged Date' },
            { field: 'remiders', headerName: 'Remiders', width: 150, description: 'Remiders' },
            { field: 'locationfrom', headerName: 'Location From', width: 150, description: 'Location From' },
        ]

    return (
        <>
            <Helmet>
                <title> Dealer | JJ Core</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'}>
                <SetDealerHeader headerName="Sets" />
                <Card>
                    <MasterTabPanel loading={loading} columns={columns} rows={rowData} masterName={masterName}
                        importHistoryColumns={importHistoryColumns} importHistoryRows={importHistoryRows}
                        noOfRecords={noOfRecords} setNoOfRecords={setNoOfRecords} importHistoryLoading={importHistoryLoading} />
                </Card>
            </Container>
        </>
    );
}
